import React from 'react';

const ContentDisplay = ({ content }) => {
  return (
    <div className="content-display">      
      <div dangerouslySetInnerHTML={{ __html: content }} />
    </div>
  );
};

export default ContentDisplay;